import { extendTheme } from "@chakra-ui/react";
export const colors = {
  brown: "#3e2723",
  badge: "#cec9bd",
  badgeLight: "#e0dbcf",
  alpha: {
    brown: (alpha: number = 1) => `rgba(62, 39, 35, ${alpha})`,
    badge: (alpha: number = 1) => `rgba(206, 201, 189, ${alpha})`,
    badgeLight: (alpha: number = 1) => `rgba(224, 219, 207, ${alpha})`,
  },
};

const theme = extendTheme({
  components: {
    CloseButton: {
      baseStyle: {
        svg: {
          color: colors.badgeLight,
        },
        bg: colors.brown,
        borderRadius: 0,
        marginBottom: "1rem",
        _hover: {
          bg: colors.brown,
          svg: {
            color: colors.badgeLight,
          },
        },
        _focus: {
          boxShadow: "none",
        },
      },
    },
    IconButton: {
      variants: {
        solid: {
          bg: "green",
          opacity: 0,
        },
      },
    },
    Tabs: {
      variants: {
        obeliski: {
          TabList: {
            display: "flex",
            justifyContent: "center",
          },
          tab: {
            width: 200,
            border: "1px solid black",
            // marginLeft: "20px",
            fontSize: 14,
            _selected: {
              bg: colors.brown,
              color: "white",
            },
            _focus: {
              outline: "none",
              boxShadow: "none",
            },
          },
        },
      },
    },

    ModalContent: {
      baseStyle: {
        bg: colors.badge,
      },
    },

    Box: {
      baseStyle: {
        bg: colors.badge,
      },
    },

    Flex: {
      baseStyle: {
        bg: colors.badge,
      },
    },

    Container: {
      baseStyle: {
        backgroundColor: colors.badge,
      },
    },

    Heading: {
      baseStyle: {
        bg: colors.brown,
        color: "white",
      },
      variants: {
        editor: {
          paddingTop: "5px",
          paddingBottom: "5px",
          paddingLeft: "1%",
          fontSize: 24,
          // marginBottom: 10,
          lineHeight: 1.1,
          fontWeight: 500,
          fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
        },
      },
    },

    Button: {
      baseStyle: {
        color: "white",
        bg: colors.brown,
        borderRadius: 0,
        _focus: {
          boxShadow: "none",
        },
      },
      variants: {
        editor: {
          fontSize: 14,
          minHeight: 35,
          transition: "all .2s linear",
          fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
          fontWeight: "normal",
        },
        controls: {
          bg: colors.badgeLight,
          color: "black",
        },
        ghost: {
          bg: "transparent",
          boxShadow: "none",
        },
        solid: {
          bg: colors.brown,
          _hover: {
            bg: colors.brown,
          },
          _active: {
            bg: "rgba(62, 39, 35, .8)",
            outline: "none",
          },
        },
      },
    },
  },
});

export default theme;
